"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.misc = void 0;
/**
 * Helper: SVG map
 * -----------------------------------------------------------------------------
 * Store for SVG icon paths to use in render functions
 * - Use SVGOMG to compress files
 * - Remove any inline fill colours
 * - Add closing tags to suppress warnings on HTML5 compatibility
 * - Add correct BEM class names
 */

var minus = "\n  <svg xmlns=\"http://www.w3.org/2000/svg\" class=\"icon icon__minus\" viewBox=\"0 0 36 36\">\n    <path d=\"M10 16h16v4H10z\"></path>\n  </svg>\n";
var plus = "\n  <svg xmlns=\"http://www.w3.org/2000/svg\" class=\"icon icon__plus\" viewBox=\"0 0 36 36\">\n    <path d=\"M16 10v6h-6v4h6v6h4v-6h6v-4h-6v-6h-4z\"></path>\n  </svg>\n";
var remove = "\n  <svg width=\"13px\" height=\"13px\" viewBox=\"0 0 18 18\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <g  stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\">\n        <g  transform=\"translate(-3.000000, -3.000000)\" stroke=\"#000000\" stroke-width=\"3\">\n            <g>\n                <g  transform=\"translate(5.000000, 5.000000)\">\n                    <path d=\"M0,0 L14.1421356,14.1421356\" ></path>\n                    <path d=\"M14,0 L1.77635684e-15,14\" ></path>\n                </g>\n            </g>\n        </g>\n    </g>\n  </svg>\n";
var misc = {
  minus: minus,
  plus: plus,
  remove: remove
};
exports.misc = misc;